import { api } from './api';

export interface DailyCheckInDto {
  id: string;
  userId: string;
  date: string;
  mood: string;
  notes: string | null;
  dailyIntention: string | null;
  morningPagesPhotoUrl: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface CreateDailyCheckInRequest {
  mood: string;
  notes?: string;
  dailyIntention?: string;
}

export interface UpdateDailyCheckInRequest {
  mood?: string;
  notes?: string;
  dailyIntention?: string;
  morningPagesPhotoUrl?: string;
}

export const dailyCheckInService = {
  async getTodayCheckIn(): Promise<DailyCheckInDto | null> {
    try {
      return await api.get<DailyCheckInDto>('/dailycheckins/today');
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'status' in error && (error as { status: number }).status === 404) {
        return null;
      }
      throw error;
    }
  },

  async getCheckInHistory(startDate?: string, endDate?: string): Promise<DailyCheckInDto[]> {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const queryString = params.toString();
    const endpoint = queryString ? `/dailycheckins?${queryString}` : '/dailycheckins';
    return api.get<DailyCheckInDto[]>(endpoint);
  },

  async createCheckIn(request: CreateDailyCheckInRequest): Promise<DailyCheckInDto> {
    return api.post<DailyCheckInDto>('/dailycheckins', request);
  },

  async updateCheckIn(id: string, request: UpdateDailyCheckInRequest): Promise<DailyCheckInDto> {
    return api.put<DailyCheckInDto>(`/dailycheckins/${id}`, request);
  },
};
